import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import JustForYouContainer from 'components/just-for-you'
import { withI18next } from 'lib/i18n/withI18next'
import { SEGMENT_REF_TYPES } from 'lib/segment/const'

const HomepageJustForYou = ({ auth, isPhone, selectedTopNavigationId }) => (
  <JustForYouContainer
    auth={auth}
    isFromHomePage
    productId={null}
    isPhone={isPhone}
    refId={selectedTopNavigationId}
    refType={SEGMENT_REF_TYPES.APP_FEED}
    isShowTitle={false}
  />
)

HomepageJustForYou.defaultProps = {
  selectedTopNavigationId: '',
}

HomepageJustForYou.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  auth: PropTypes.shape({}).isRequired,
  selectedTopNavigationId: PropTypes.string,
}

export default compose(
  connect((state) => ({
    auth: state.auth,
    isPhone: state.device.isPhone,
    selectedTopNavigationId: state.homePage.selectedTopNavigation?.id,
  })),
  withI18next(),
)(HomepageJustForYou)
